import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { SiteLayout } from "@/components/site/SiteLayout";
import HomePage from "@/pages/HomePage";
import CatalogPage from "@/pages/CatalogPage";
import MagazineDetailPage from "@/pages/MagazineDetailPage";
import ReaderPage from "@/pages/ReaderPage";
import PublishersPage from "@/pages/PublishersPage";
import PublisherDetailPage from "@/pages/PublisherDetailPage";
import PricingPage from "@/pages/PricingPage";
import { CheckoutPage, MockPayPage, CheckoutSuccessPage, CheckoutFailedPage } from "@/pages/CheckoutPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import { AboutPage, ContactPage } from "@/pages/StaticPages";
import { BlogListPage, BlogPostPage } from "@/pages/BlogPages";
import { NotFound } from "@/components/site/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminMagazines from "@/pages/admin/AdminMagazines";
import MagazineForm from "@/pages/admin/MagazineForm";
import { AdminPublishers, PublisherForm } from "@/pages/admin/AdminPublishers";
import { AdminPlans, PlanForm } from "@/pages/admin/AdminPlans";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminUploads from "@/pages/admin/AdminUploads";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/magazines" element={<CatalogPage />} />
            <Route path="/magazines/:slug" element={<MagazineDetailPage />} />
            <Route path="/publishers" element={<PublishersPage />} />
            <Route path="/publishers/:slug" element={<PublisherDetailPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/subscribe" element={<PricingPage />} />
            <Route path="/checkout/:planId" element={<CheckoutPage />} />
            <Route path="/checkout/mock/:orderId" element={<MockPayPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/checkout/failed" element={<CheckoutFailedPage />} />
            <Route path="/track" element={<TrackOrderPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/read/:slug" element={<ReaderPage />} />
          <Route path="/apadmin/login" element={<AdminLogin />} />
          <Route path="/apadmin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="magazines" element={<AdminMagazines />} />
            <Route path="magazines/new" element={<MagazineForm />} />
            <Route path="magazines/:id/edit" element={<MagazineForm />} />
            <Route path="publishers" element={<AdminPublishers />} />
            <Route path="publishers/new" element={<PublisherForm />} />
            <Route path="publishers/:id/edit" element={<PublisherForm />} />
            <Route path="plans" element={<AdminPlans />} />
            <Route path="plans/new" element={<PlanForm />} />
            <Route path="plans/:id/edit" element={<PlanForm />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="uploads" element={<AdminUploads />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
